import type { ServerTime } from '@/modules/common/adapters/server-time.type.ts';
import type { ServerTimeDto } from '@/modules/common/dto/server-time.dto.ts';

export class ServerTimeAdapter {
  static map(response: ServerTimeDto): ServerTime {
    return {
      utc: response['utc_time'],
      timezone: response['timezone'],
      location: response['location'],
    };
  }
}
